module.exports = __webpack_public_path__ + "static/img/gr-977-375bb.22bf2ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gr-977-375bb.jpg
// module id = xUiJ
// module chunks = 0